import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { InviteAcceptPage } from '@/features/groups/components';

function InviteAcceptRoute(): ReactNode {
  const { token } = Route.useParams();
  // No AuthGuard — the invite preview is a public surface so a guest can
  // see what room they're being invited into and decide whether to sign
  // in. The accept mutation itself requires auth and the page bounces
  // back through /login when the user is signed out.
  return <InviteAcceptPage token={token} />;
}

export const Route = createFileRoute('/invites/$token')({
  component: InviteAcceptRoute,
});
